/**
 * @generated SignedSource<<bee7eca60e9b14088c3946aa37977187>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFeedPostUpdateMutation_brand$data = {
  readonly id: string;
  readonly " $fragmentType": "useFeedPostUpdateMutation_brand";
};
export type useFeedPostUpdateMutation_brand$key = {
  readonly " $data"?: useFeedPostUpdateMutation_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFeedPostUpdateMutation_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFeedPostUpdateMutation_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "1e5e9696f1a7849e768266dd31f725bb";

export default node;
